import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { MessageDisplayUtil } from 'src/message-display-utils';

@Component({
  selector: 'app-check-in',
  templateUrl: './check-in.component.html',
  styleUrls: ['./check-in.component.scss'],
})
export class CheckInComponent implements OnInit {

  @Input() bookingType: any;
  @Input() bookingSlot: any;
  @Input() arrivalOption: any;
  @Input() checkInPlayers: any;
  @Input() etaCounter: number = 30;
  @Input() checkInAllPlayers: boolean = false;
  @Input() getPlayerSlotDetails: (slot: number, attribute: string) => void;

  constructor(
    public platform: Platform,
    private modalCtl: ModalController,
    private toastCtl: ToastController,
    private mg2uUtils: mygolfUtils
  ) { }

  ngOnInit() { }

  addETAcounter(type: number) {
    if (type > 0 && this.etaCounter === 60) return false;
    else if (type < 0 && this.etaCounter === 0) return false;
    if (type === 1) this.etaCounter += 5;
    else if (type === -1) this.etaCounter -= 5;
  }

  onCheckInAll() {
    if (this.checkInAllPlayers) {
    this.checkInPlayers = [true, true, true, true, true, true]
    } else {
      this.checkInPlayers = [false, false, false, false, false, false]
    }
  }
  backRouting() {
    this.modalCtl.dismiss();
  }

  saveAndDismiss(save: boolean){


    if(this.arrivalOption==="eta"){
      var count = 0;
      this.checkInPlayers.forEach(element => {
        if(element){
          count++
        }
      });

      if(count==0){
        MessageDisplayUtil.showMessageToast(
          'Please select at least one (1) player to check-in',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }
    }

    if(save){
      this.modalCtl.dismiss({
        etaCounter: this.etaCounter,
        arrivalOption: this.arrivalOption,
        checkInPlayers: this.checkInPlayers,
        checkInAllPlayers: this.checkInAllPlayers,

      });
    }else{
      this.modalCtl.dismiss();
    }
  }

  isMobileLayout() {
    return this.mg2uUtils.isMobileLayout();
  }

  goToHome() {
    this.mg2uUtils.goToHome();
  }
}
